import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes calPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}
  *{box-sizing:border-box}
  .wr-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .wr-select{width:100%;padding:12px 16px;background:#fff7ed;border:1.5px solid #fed7aa;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23f97316' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .wr-select:focus{border-color:#f97316;box-shadow:0 0 0 3px rgba(249,115,22,0.15)}
  .wr-select:disabled{background:#f5f5f5;color:#a0aec0;cursor:not-allowed}
  .wr-input{width:100%;padding:12px 16px;background:#fff7ed;border:1.5px solid #fed7aa;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .wr-input:focus{border-color:#f97316;background:#fff;box-shadow:0 0 0 3px rgba(249,115,22,0.15)}
  .wr-input::placeholder{color:#a0aec0}
  .wr-input[type=date]{cursor:pointer}
  .wr-btn-primary{padding:12px 28px;background:linear-gradient(135deg,#fb923c,#ea580c);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px}
  .wr-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(234,88,12,0.4)}
  .wr-btn-primary:disabled{opacity:0.6;cursor:not-allowed;transform:none}
  .wr-btn-secondary{padding:11px 22px;background:#fff7ed;border:1.5px solid #fed7aa;
    border-radius:12px;color:#c2410c;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .wr-btn-secondary:hover{background:#ffedd5;border-color:#f97316}
  .wr-row:hover td{background:#fff7ed !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .skeleton{background:linear-gradient(90deg,#fff7ed 25%,#ffedd5 50%,#fff7ed 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(249,115,22,0.15);color:#fb923c;border-left:3px solid #fb923c;padding-left:13px}
  .wr-label{font-size:11px;font-weight:700;color:#9a3412;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}
  .type-toggle{display:flex;gap:8px}
  .type-opt{flex:1;padding:11px;border-radius:12px;border:1.5px solid #fed7aa;cursor:pointer;
    text-align:center;font-size:13px;font-weight:600;font-family:'DM Sans',sans-serif;
    transition:all 0.2s;background:#fff7ed;color:#9a3412}
  .type-opt:hover{border-color:#f97316;background:#ffedd5}
  .type-opt.selected-high{background:linear-gradient(135deg,#dc2626,#b91c1c);
    border-color:#dc2626;color:#fff;box-shadow:0 4px 14px rgba(220,38,38,0.3)}
  .type-opt.selected-low{background:linear-gradient(135deg,#16a34a,#15803d);
    border-color:#16a34a;color:#fff;box-shadow:0 4px 14px rgba(22,163,74,0.3)}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#fed7aa;border-radius:3px}
  .filter-pill{padding:6px 14px;border-radius:20px;border:1.5px solid #fed7aa;
    background:#fff7ed;color:#9a3412;font-size:12px;font-weight:600;cursor:pointer;
    font-family:'DM Sans',sans-serif;transition:all 0.18s}
  .filter-pill.on{background:#f97316;border-color:#f97316;color:#fff;
    box-shadow:0 4px 12px rgba(249,115,22,0.3)}
  .filter-pill:hover:not(.on){border-color:#f97316;background:#ffedd5}
  .search-box{padding:9px 14px 9px 38px;border:1.5px solid #fed7aa;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:220px;
    transition:border-color 0.2s,width 0.3s;color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-box:focus{border-color:#f97316;box-shadow:0 0 0 3px rgba(249,115,22,0.12);width:280px}
  .cb-wrap{display:flex;align-items:center;gap:8px;cursor:pointer}
  .cb-box{width:18px;height:18px;border-radius:5px;border:2px solid #fed7aa;
    display:flex;align-items:center;justify-content:center;flex-shrink:0;
    transition:all 0.18s;background:#fff}
  .cb-box.on{background:#f97316;border-color:#f97316}
  .cb-box.on::after{content:'✓';color:#fff;font-size:11px;font-weight:800}
`;

// const NAV = [
//   {icon:'⬡',  label:'Dashboard',        path:'/dashboard'},
//   {icon:'👥',  label:'User Management',  path:'/user-management'},
//   {icon:'⏱️',  label:'Rent Durations',   path:'/rent-durations'},
//   {icon:'💰',  label:'Car Price',        path:'/car-price'},
//   {icon:'🚕',  label:'Transfer Price',   path:'/transfer-price'},
//   {icon:'📅',  label:'Weekend Rate',     path:'/weekend-rate'},
//   {icon:'📋',  label:'Bookings',         path:'/bookings'},
//   {icon:'🚘',  label:'Vehicles',         path:'/vehicles'},
//   {icon:'👤',  label:'Customers',        path:'/customers'},
//   {icon:'💳',  label:'Payments',         path:'/payments'},
// ];

const EMPTY = {
  group_id:'', car_id:'', weekend_rate:'',
  from_date:'', to_date:'', weekendrate_type:'1'
};

export default function WeekendRate() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,    setAuthUser]    = useState(null);
  const [sideOpen,    setSideOpen]    = useState(true);
  const [groups,      setGroups]      = useState([]);
  const [cars,        setCars]        = useState([]);
  const [rates,       setRates]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [form,        setForm]        = useState(EMPTY);
  const [editId,      setEditId]      = useState(null);
  const [saving,      setSaving]      = useState(false);
  const [carsLoading, setCarsLoading] = useState(false);
  const [viewModal,   setViewModal]   = useState(null);
  const [delModal,    setDelModal]    = useState(null);
  const [delSaving,   setDelSaving]   = useState(false);
  const [selected,    setSelected]    = useState([]);
  const [search,      setSearch]      = useState('');
  const [groupFilter, setGroupFilter] = useState('all');
  const [typeFilter,  setTypeFilter]  = useState('all');
  const [page,        setPage]        = useState(1);
  const [toast,       setToast]       = useState(null);
  const PER = 8;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchGroups();
    fetchRates();
  }, []);

  const fetchGroups = async () => {
    try {
      const r = await API.get('/weekend-rate/groups');
      setGroups(r.data);
    } catch(e) { console.error(e); }
  };

  const fetchRates = async (gid) => {
    setLoading(true);
    try {
      const params = gid && gid !== 'all' ? `?groupId=${gid}` : '';
      const r = await API.get(`/weekend-rate${params}`);
      setRates(r.data);
    } catch(e) { showToast('Failed to load weekend rates', 'error'); }
    setLoading(false);
  };

  const loadCars = async (groupId) => {
    if (!groupId) { setCars([]); return; }
    setCarsLoading(true);
    try {
      const r = await API.get(`/weekend-rate/cars/${groupId}`);
      setCars(r.data);
    } catch(e) { console.error(e); }
    setCarsLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm(EMPTY);
    setEditId(null);
    setCars([]);
  }, []);

  const startEdit = async (rec) => {
    await loadCars(rec.group_id);
    setForm({
      group_id:        String(rec.group_id),
      car_id:          String(rec.car_id),
      weekend_rate:    rec.weekend_rate,
      from_date:       rec.from_date?.split('T')[0] || rec.from_date || '',
      to_date:         rec.to_date?.split('T')[0]   || rec.to_date   || '',
      weekendrate_type: String(rec.weekendrate_type),
    });
    setEditId(rec.weekendrate_id);
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleGroupChange = (gid) => {
    setForm(p => ({...p, group_id:gid, car_id:''}));
    loadCars(gid);
  };

  const handleSubmit = async () => {
    if (!form.group_id || !form.car_id || !form.weekend_rate || !form.from_date || !form.to_date) {
      showToast('All fields are required', 'error'); return;
    }
    if (new Date(form.to_date) < new Date(form.from_date)) {
      showToast('To Date must be after From Date', 'error'); return;
    }
    const rate = parseFloat(form.weekend_rate);
    if (isNaN(rate) || rate < 0 || rate > 999) {
      showToast('Weekend rate must be between 0 and 999', 'error'); return;
    }
    setSaving(true);
    try {
      if (editId) {
        await API.put(`/weekend-rate/${editId}`, form);
        showToast('Weekend rate updated ✓');
      } else {
        await API.post('/weekend-rate', form);
        showToast('Weekend rate added ✓');
      }
      await fetchRates();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    setDelSaving(true);
    try {
      await API.delete(`/weekend-rate/${id}`);
      showToast('Weekend rate deleted ✓');
      setDelModal(null);
      setSelected(s => s.filter(i => i !== id));
      if (editId === id) resetForm();
      await fetchRates();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const handleBulkDelete = async () => {
    if (!selected.length) return;
    if (!window.confirm(`Delete ${selected.length} selected record(s)?`)) return;
    setSaving(true);
    try {
      await Promise.all(selected.map(id => API.delete(`/weekend-rate/${id}`)));
      showToast(`${selected.length} record(s) deleted ✓`);
      setSelected([]);
      await fetchRates();
    } catch(e) {
      showToast('Bulk delete failed', 'error');
    }
    setSaving(false);
  };

  const toggleSelect = (id) =>
    setSelected(s => s.includes(id) ? s.filter(i=>i!==id) : [...s,id]);
  const toggleAll = () =>
    setSelected(s => s.length === paged.length ? [] : paged.map(r=>r.weekendrate_id));

  const handleGroupFilter = (gid) => {
    setGroupFilter(gid);
    setPage(1);
    fetchRates(gid !== 'all' ? gid : undefined);
  };

  const filtered = rates.filter(r => {
    const q = search.toLowerCase();
    const ms = !search ||
      r.car_name?.toLowerCase().includes(q) ||
      r.group_name?.toLowerCase().includes(q);
    const mt = typeFilter === 'all' || String(r.weekendrate_type) === typeFilter;
    return ms && mt;
  });
  const totalPages = Math.ceil(filtered.length / PER);
  const paged      = filtered.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };
  const f          = (k) => (e) => setForm(p => ({...p, [k]: e.target.value}));

  const fmtDate = (d) => {
    if (!d) return '—';
    const dt = new Date(d);
    return isNaN(dt) ? d : dt.toLocaleDateString('en-IN', {day:'2-digit',month:'short',year:'numeric'});
  };

  const daysBetween = (a, b) => {
    if (!a || !b) return null;
    const diff = (new Date(b) - new Date(a)) / (1000*60*60*24);
    return diff >= 0 ? Math.round(diff) + 1 : null;
  };

  return (
    <Layout activePage="Weekend Rate">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="wr-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen ? 220 : 68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={() => setSideOpen(p=>!p)}>
              {sideOpen ? '◀' : '▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n => (
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={() => navigate(n.path)}>
                <span style={{fontSize:16, flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main>

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Weekend Rate</h1>
              <p style={S.pageSub}>Manage high/low rate adjustments per car</p>
            </div>
            <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
              {[
                {label:'Total Rates', value:rates.length,                                    color:'#ea580c', bg:'#fff7ed', icon:'📅'},
                {label:'High', value:rates.filter(r=>String(r.weekendrate_type)==='1').length, color:'#dc2626', bg:'#fef2f2', icon:'🔴'},
                {label:'Low',  value:rates.filter(r=>String(r.weekendrate_type)==='2').length, color:'#16a34a', bg:'#f0fdf4', icon:'🟢'},
              ].map(s => (
                <div key={s.label} style={{...S.miniStat, background:s.bg}}>
                  <span style={{fontSize:22}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId ? '✏️' : '📅'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>
                  {editId ? 'Edit Weekend Rate' : 'Add Weekend Rate'}
                </h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing: ${rates.find(r=>r.weekendrate_id===editId)?.car_name}`
                    : 'Configure high or low rate adjustments for a specific car and date range'}
                </p>
              </div>
              {editId && (
                <button className="wr-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            {/* Row 1 — Group + Car */}
            <div style={S.formGrid2}>
              <div>
                <label className="wr-label">Car Group *</label>
                <select className="wr-select" value={form.group_id}
                  onChange={e => handleGroupChange(e.target.value)}>
                  <option value="">— Select Group —</option>
                  {groups.map(g => (
                    <option key={g.group_id} value={g.group_id}>{g.group_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="wr-label">Car *</label>
                <select className="wr-select" value={form.car_id}
                  disabled={!form.group_id || carsLoading}
                  onChange={f('car_id')}>
                  <option value="">
                    {carsLoading ? 'Loading…' : form.group_id ? '— Select Car —' : '— Select Group First —'}
                  </option>
                  {cars.map(c => (
                    <option key={c.car_id} value={c.car_id}>{c.car_name}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2 — Dates + Rate */}
            <div style={{...S.formGrid3, marginTop:16}}>
              <div>
                <label className="wr-label">From Date *</label>
                <input className="wr-input" type="date" value={form.from_date}
                  onChange={f('from_date')}/>
              </div>
              <div>
                <label className="wr-label">To Date *</label>
                <input className="wr-input" type="date" value={form.to_date}
                  min={form.from_date}
                  onChange={f('to_date')}/>
                {form.from_date && form.to_date && (
                  <div style={{fontSize:11,color:'#9a3412',marginTop:4,fontWeight:600}}>
                    📅 {daysBetween(form.from_date, form.to_date)} day(s)
                  </div>
                )}
              </div>
              <div>
                <label className="wr-label">Weekend Rate (%) *</label>
                <div style={{position:'relative'}}>
                  <input className="wr-input" type="number" min="0" max="999" step="0.01"
                    placeholder="e.g. 20" value={form.weekend_rate}
                    onChange={f('weekend_rate')}
                    style={{paddingRight:40}}/>
                  <span style={{position:'absolute',right:14,top:'50%',transform:'translateY(-50%)',
                    color:'#ea580c',fontWeight:800,fontSize:16}}>%</span>
                </div>
              </div>
            </div>

            {/* Row 3 — Rate Type */}
            <div style={{marginTop:16}}>
              <label className="wr-label">Rate Type *</label>
              <div className="type-toggle">
                {[
                  {val:'1', label:'🔴 High', sub:'Rate increase / surcharge', cls:'selected-high'},
                  {val:'2', label:'🟢 Low',  sub:'Rate decrease / discount',  cls:'selected-low'},
                ].map(opt => (
                  <div key={opt.val}
                    className={`type-opt${form.weekendrate_type===opt.val?' '+opt.cls:''}`}
                    onClick={() => setForm(p => ({...p, weekendrate_type:opt.val}))}>
                    <div style={{fontSize:15,fontWeight:700}}>{opt.label}</div>
                    <div style={{fontSize:11,marginTop:3,opacity:0.8}}>{opt.sub}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Live preview */}
            {form.weekend_rate && form.from_date && form.to_date && (
              <div style={S.previewBox}>
                <div style={{fontSize:13,fontWeight:700,color:'#c2410c',marginBottom:12}}>
                  📊 Rate Preview — How it affects base price
                </div>
                <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                  {[500, 1000, 2000, 5000].map(base => {
                    const pct   = parseFloat(form.weekend_rate) || 0;
                    const isHigh = form.weekendrate_type === '1';
                    const adj   = base * pct / 100;
                    const final = isHigh ? base + adj : base - adj;
                    return (
                      <div key={base} style={{background:'#fff',borderRadius:12,
                        padding:'12px 16px',border:'1.5px solid #fed7aa',textAlign:'center',minWidth:110}}>
                        <div style={{fontSize:11,color:'#a0aec0',fontWeight:600}}>Base ₹{base}</div>
                        <div style={{fontSize:9,color:'#a0aec0',margin:'2px 0'}}>
                          {isHigh?'+':'-'}{pct}%
                        </div>
                        <div style={{fontSize:18,fontWeight:800,
                          color:isHigh?'#dc2626':'#16a34a'}}>
                          ₹{Math.round(final)}
                        </div>
                        <div style={{fontSize:9,color:isHigh?'#dc2626':'#16a34a',fontWeight:600}}>
                          {isHigh?'▲ surcharge':'▼ discount'}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{fontSize:11,color:'#9a3412',marginTop:10}}>
                  Active from <strong>{fmtDate(form.from_date)}</strong> to <strong>{fmtDate(form.to_date)}</strong>
                  &nbsp;·&nbsp; {daysBetween(form.from_date,form.to_date)} day(s)
                </div>
              </div>
            )}

            {/* Submit */}
            <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end'}}>
              {editId && <button className="wr-btn-secondary" onClick={resetForm}>Cancel</button>}
              <button className="wr-btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving
                  ? <span style={S.spinner}/>
                  : editId ? '💾 Update Rate' : '＋ Add Weekend Rate'}
              </button>
            </div>
          </div>

          {/* ── Manage Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Weekend Rates</h3>
              <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>

                {/* Group filter */}
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  <button className={`filter-pill${groupFilter==='all'?' on':''}`}
                    onClick={()=>handleGroupFilter('all')}>All Groups</button>
                  {groups.map(g=>(
                    <button key={g.group_id}
                      className={`filter-pill${groupFilter===String(g.group_id)?' on':''}`}
                      onClick={()=>handleGroupFilter(String(g.group_id))}>
                      {g.group_name}
                    </button>
                  ))}
                </div>

                {/* Type filter */}
                <div style={{display:'flex',gap:6}}>
                  {[['all','All'],['1','🔴 High'],['2','🟢 Low']].map(([v,l])=>(
                    <button key={v}
                      className={`filter-pill${typeFilter===v?' on':''}`}
                      onClick={()=>{setTypeFilter(v);setPage(1);}}>
                      {l}
                    </button>
                  ))}
                </div>

                {/* Search */}
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                    color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
                  <input className="search-box" placeholder="Search car or group…"
                    value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
                </div>

                <span style={{fontSize:12,background:'#fff7ed',color:'#c2410c',
                  borderRadius:20,padding:'4px 14px',fontWeight:700,whiteSpace:'nowrap'}}>
                  {filtered.length} records
                </span>

                {/* Bulk delete */}
                {selected.length > 0 && (
                  <button onClick={handleBulkDelete} disabled={saving}
                    style={{padding:'7px 16px',background:'#dc2626',border:'none',
                      borderRadius:10,color:'#fff',fontWeight:700,fontSize:13,
                      cursor:'pointer',fontFamily:'DM Sans,sans-serif',
                      display:'flex',alignItems:'center',gap:6}}>
                    🗑 Delete ({selected.length})
                  </button>
                )}
              </div>
            </div>

            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#fff7ed,#ffedd5)'}}>
                    <th style={S.th}>
                      <div className="cb-wrap" onClick={toggleAll}>
                        <div className={`cb-box${selected.length===paged.length&&paged.length>0?' on':''}`}/>
                      </div>
                    </th>
                    {['Car','Group','From Date','To Date','Rate','Duration','Type','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:5}).map((_,i)=>(
                        <tr key={i}>
                          {Array.from({length:9}).map((_,j)=>(
                            <td key={j} style={S.td}>
                              <div className="skeleton" style={{height:14,width:'70%'}}/>
                            </td>
                          ))}
                        </tr>
                      ))
                    : paged.length===0
                    ? (
                        <tr>
                          <td colSpan={9} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:40,marginBottom:10}}>📅</div>
                            <div style={{fontSize:15,fontWeight:600}}>No weekend rates found</div>
                            <div style={{fontSize:13,marginTop:4}}>Use the form above to add your first rate</div>
                          </td>
                        </tr>
                      )
                    : paged.map((r,i)=>{
                        const isHigh = String(r.weekendrate_type) === '1';
                        const days   = daysBetween(r.from_date, r.to_date);
                        const isSel  = selected.includes(r.weekendrate_id);
                        return (
                          <tr key={r.weekendrate_id} className="wr-row"
                            style={{borderBottom:'1px solid #fff7ed',
                              background:editId===r.weekendrate_id?'#fff7ed':isSel?'#fff7ed':i%2===0?'#fff':'#fffbf7'}}>
                            <td style={S.td}>
                              <div className="cb-wrap" onClick={()=>toggleSelect(r.weekendrate_id)}>
                                <div className={`cb-box${isSel?' on':''}`}/>
                              </div>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',alignItems:'center',gap:10}}>
                                <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                                  background:isHigh
                                    ?'linear-gradient(135deg,#fca5a5,#dc2626)'
                                    :'linear-gradient(135deg,#86efac,#16a34a)',
                                  display:'flex',alignItems:'center',justifyContent:'center',
                                  fontSize:16}}>
                                  {isHigh?'🔴':'🟢'}
                                </div>
                                <div>
                                  <div style={{fontWeight:700,fontSize:14,color:'#1a1d2e'}}>{r.car_name}</div>
                                  {editId===r.weekendrate_id&&(
                                    <span style={{fontSize:10,background:'#fef9c3',color:'#854d0e',
                                      padding:'1px 6px',borderRadius:10,fontWeight:700}}>EDITING</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={S.td}>
                              <span className="badge" style={{background:'#fff7ed',color:'#c2410c'}}>
                                {r.group_name}
                              </span>
                            </td>
                            <td style={{...S.td,fontSize:13,fontWeight:600,color:'#4a5568'}}>
                              {fmtDate(r.from_date)}
                            </td>
                            <td style={{...S.td,fontSize:13,fontWeight:600,color:'#4a5568'}}>
                              {fmtDate(r.to_date)}
                            </td>
                            <td style={S.td}>
                              <div style={{fontWeight:800,fontSize:18,
                                color:isHigh?'#dc2626':'#16a34a'}}>
                                {isHigh?'▲':'▼'} {r.weekend_rate}%
                              </div>
                            </td>
                            <td style={S.td}>
                              {days && (
                                <span className="badge" style={{background:'#fef9c3',color:'#854d0e'}}>
                                  {days} day{days!==1?'s':''}
                                </span>
                              )}
                            </td>
                            <td style={S.td}>
                              <span className="badge"
                                style={isHigh
                                  ?{background:'#fef2f2',color:'#dc2626',border:'1.5px solid #fca5a5'}
                                  :{background:'#f0fdf4',color:'#16a34a',border:'1.5px solid #86efac'}}>
                                {isHigh ? '🔴 High' : '🟢 Low'}
                              </span>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',gap:6}}>
                                <button className="action-btn"
                                  style={{background:'#fff7ed',color:'#c2410c'}}
                                  title="View" onClick={()=>setViewModal(r)}>👁</button>
                                <button className="action-btn"
                                  style={{background:'#fefcbf',color:'#744210'}}
                                  title="Edit" onClick={()=>startEdit(r)}>✏️</button>
                                <button className="action-btn"
                                  style={{background:'#fff5f5',color:'#c53030'}}
                                  title="Delete" onClick={()=>setDelModal(r)}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:480}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>📅 Weekend Rate Details</h2>
                  <p style={S.modalSub}>{viewModal.car_name} · {viewModal.group_name}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'20px 28px'}}>
                {/* Hero */}
                <div style={{background:String(viewModal.weekendrate_type)==='1'
                  ?'linear-gradient(135deg,#fef2f2,#fee2e2)'
                  :'linear-gradient(135deg,#f0fdf4,#dcfce7)',
                  borderRadius:16,padding:'20px',
                  border:`1.5px solid ${String(viewModal.weekendrate_type)==='1'?'#fca5a5':'#86efac'}`,
                  textAlign:'center',marginBottom:20}}>
                  <div style={{fontSize:40,marginBottom:8}}>
                    {String(viewModal.weekendrate_type)==='1'?'🔴':'🟢'}
                  </div>
                  <div style={{fontSize:36,fontWeight:800,
                    color:String(viewModal.weekendrate_type)==='1'?'#dc2626':'#16a34a'}}>
                    {String(viewModal.weekendrate_type)==='1'?'▲ +':'▼ −'}{viewModal.weekend_rate}%
                  </div>
                  <div style={{fontSize:14,fontWeight:600,marginTop:4,
                    color:String(viewModal.weekendrate_type)==='1'?'#991b1b':'#15803d'}}>
                    {String(viewModal.weekendrate_type)==='1'?'High Surcharge':'Low  Discount'}
                  </div>
                </div>

                {[
                  {label:'Car',        value:viewModal.car_name,        icon:'🚗'},
                  {label:'Car Group',  value:viewModal.group_name,      icon:'🗂️'},
                  {label:'From Date',  value:fmtDate(viewModal.from_date), icon:'📅'},
                  {label:'To Date',    value:fmtDate(viewModal.to_date),   icon:'📅'},
                  {label:'Duration',   value:`${daysBetween(viewModal.from_date,viewModal.to_date)||'—'} days`, icon:'⏱️'},
                  {label:'Rate Type',  value:String(viewModal.weekendrate_type)==='1'?'High':'Low', icon:'📊'},
                ].map(row=>(
                  <div key={row.label} style={{display:'flex',alignItems:'center',gap:14,
                    padding:'11px 0',borderBottom:'1px solid #fff7ed'}}>
                    <div style={{width:34,height:34,background:'#fff7ed',borderRadius:10,
                      display:'flex',alignItems:'center',justifyContent:'center',
                      fontSize:15,flexShrink:0}}>{row.icon}</div>
                    <div>
                      <div style={{fontSize:11,color:'#9a3412',fontWeight:600,
                        textTransform:'uppercase',letterSpacing:'0.4px'}}>{row.label}</div>
                      <div style={{fontSize:14,color:'#1a1d2e',fontWeight:600,marginTop:2}}>{row.value}</div>
                    </div>
                  </div>
                ))}

                {/* Impact preview */}
                <div style={{marginTop:16,background:'#fff7ed',borderRadius:12,
                  padding:'14px 16px',border:'1.5px solid #fed7aa'}}>
                  <div style={{fontSize:12,fontWeight:700,color:'#c2410c',marginBottom:10}}>
                    Impact on Sample Prices
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
                    {[500,1000,2000].map(base=>{
                      const pct = parseFloat(viewModal.weekend_rate)||0;
                      const isH = String(viewModal.weekendrate_type)==='1';
                      const adj = base * pct / 100;
                      const fin = isH ? base+adj : base-adj;
                      return (
                        <div key={base} style={{background:'#fff',borderRadius:8,
                          padding:'8px',textAlign:'center',border:'1px solid #fed7aa'}}>
                          <div style={{fontSize:10,color:'#a0aec0'}}>₹{base}</div>
                          <div style={{fontSize:14,fontWeight:800,
                            color:isH?'#dc2626':'#16a34a'}}>₹{Math.round(fin)}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div style={S.modalFoot}>
                <button className="wr-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="wr-btn-primary"
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Rate
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Weekend Rate?</h2>
                <div style={{marginBottom:16,display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                  <span className="badge" style={{background:'#fff7ed',color:'#c2410c'}}>
                    🚗 {delModal.car_name}
                  </span>
                  <span className="badge" style={{
                    background:String(delModal.weekendrate_type)==='1'?'#fef2f2':'#f0fdf4',
                    color:String(delModal.weekendrate_type)==='1'?'#dc2626':'#16a34a'}}>
                    {String(delModal.weekendrate_type)==='1'?'▲':'▼'} {delModal.weekend_rate}%
                  </span>
                  <span className="badge" style={{background:'#fef9c3',color:'#854d0e'}}>
                    {fmtDate(delModal.from_date)} → {fmtDate(delModal.to_date)}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  Are you sure you want to delete this weekend rate?<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="wr-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={()=>handleDelete(delModal.weekendrate_id)}
                    style={{padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                      border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                      fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                      display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#fff7ed',
            borderColor:toast.type==='error'?'#fc8181':'#fb923c',
            color:toast.type==='error'?'#c53030':'#c2410c'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

const S = {
  root:{display:'flex',minHeight:'100vh',background:'#fffbf5'},

//   sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
//     position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
//   sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
//   logoWrap:{display:'flex',alignItems:'center',gap:10},
//   logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#fb923c,#ea580c)',borderRadius:10,
//     display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
//   logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
//   collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
//     padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
//   sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
//   userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
//   avatar:{width:36,height:36,background:'linear-gradient(135deg,#fb923c,#ea580c)',borderRadius:'50%',
//     display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
//   uname:{fontSize:13,fontWeight:700,color:'#fff'},
//   urole:{fontSize:11,color:'#777'},
//   logoutBtn:{width:'100%',background:'rgba(251,146,60,0.12)',border:'1px solid rgba(251,146,60,0.25)',
//     color:'#fb923c',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
//     display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(234,88,12,0.08)',marginBottom:24,border:'1.5px solid #fed7aa'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:22},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#fb923c,#ea580c)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(234,88,12,0.3)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  formGrid2:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16},
  formGrid3:{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16},
  previewBox:{marginTop:20,background:'linear-gradient(135deg,#fff7ed,#ffedd5)',
    borderRadius:14,padding:'18px 20px',border:'1.5px solid #fed7aa'},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(234,88,12,0.08)',marginBottom:20,border:'1.5px solid #fed7aa'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #fff7ed',flexWrap:'wrap',gap:12},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'13px 16px',fontSize:11,fontWeight:700,color:'#9a3412',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #ffedd5'},
  td:{padding:'13px 16px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #fff7ed'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #fed7aa',borderRadius:8,background:'#fff',
    color:'#9a3412',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#f97316',borderColor:'#f97316',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,5,0,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(234,88,12,0.2)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #fff7ed',flexShrink:0},
  xBtn:{background:'rgba(251,146,60,0.15)',border:'none',color:'#ea580c',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};